/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadPalReportToExternalEhrConfig
 */
export interface UploadPalReportToExternalEhrConfig {
    /**
     * 
     */
    external_ehr_type: UploadPalReportToExternalEhrConfigExternalEhrTypeEnum;
    /**
     * 
     */
    upload: boolean;
}


/**
 * @export
 */
export const UploadPalReportToExternalEhrConfigExternalEhrTypeEnum = {
    Pcc: 'PCC',
    MatrixCare: 'MATRIX_CARE',
    Hchb: 'HCHB',
    MatrixCareHomeHealth: 'MATRIX_CARE_HOME_HEALTH',
    Kinnser: 'KINNSER',
} as const;
export type UploadPalReportToExternalEhrConfigExternalEhrTypeEnum = typeof UploadPalReportToExternalEhrConfigExternalEhrTypeEnum[keyof typeof UploadPalReportToExternalEhrConfigExternalEhrTypeEnum];


/**
 * Check if a given object implements the UploadPalReportToExternalEhrConfig interface.
 */
export function instanceOfUploadPalReportToExternalEhrConfig(value: object): value is UploadPalReportToExternalEhrConfig {
    if (!('external_ehr_type' in value) || value['external_ehr_type'] === undefined) return false;
    if (!('upload' in value) || value['upload'] === undefined) return false;
    return true;
}

export function UploadPalReportToExternalEhrConfigFromJSON(json: any): UploadPalReportToExternalEhrConfig {
    return UploadPalReportToExternalEhrConfigFromJSONTyped(json, false);
}

export function UploadPalReportToExternalEhrConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadPalReportToExternalEhrConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'external_ehr_type': json['external_ehr_type'],
        'upload': json['upload'],
    };
}

export function UploadPalReportToExternalEhrConfigToJSON(json: any): UploadPalReportToExternalEhrConfig {
    return UploadPalReportToExternalEhrConfigToJSONTyped(json, false);
}

export function UploadPalReportToExternalEhrConfigToJSONTyped(value?: UploadPalReportToExternalEhrConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'external_ehr_type': value['external_ehr_type'],
        'upload': value['upload'],
    };
}

